/* @flow */
import PusherActions from 'pusher/PusherActions';
import SettingsStore from 'stores/SettingsStore';
import { openConnection, closeConnection, resetConnection } from 'pusher/PusherConnection';
import { promiseSettings } from 'promises/userBootData';

class PusherClient {
  _subscribed: Object = {};

  _getKey() {
    return promiseSettings().then(() => SettingsStore.getPusherKey());
  }

  /**
   * @return {Promise} for a Pusher connection using the key in SettingsStore
   */
  _getOpenConnection() {
    return this._getKey().then(openConnection);
  }

  /**
   * @return {Promise} for a Pusher channel
   */
  subscribe(channelName: string) {
    this._subscribed[channelName] = true;
    return this._getOpenConnection().then(conn => conn.subscribe(channelName));
  }

  unsubscribe(channelName: string) {
    if (this.isSubscribedTo(channelName)) {
      delete this._subscribed[channelName];
      this._getOpenConnection()
        .then(conn => conn.unsubscribe(channelName))
        .catch(e => console.error('PusherClient unsubscribe failed', e));
    }
  }

  unsubscribeAll() {
    for (const channel in this._subscribed) {
      this.unsubscribe(channel);
    }
  }

  disconnectAndCleanUp() {
    closeConnection();

    PusherActions.resetStore();
  }

  isSubscribedTo(channelName: string) {
    return channelName in this._subscribed;
  }

  bind(state: string, callback: Function) {
    this._getOpenConnection()
      .then(conn => conn.bind(state, callback))
      .catch(e => console.error('PusherClient bind failed', e));
  }

  retry() {
    resetConnection();
  }

}

export default new PusherClient();



// WEBPACK FOOTER //
// ./src/pusher/PusherClient.js